import { createContext, useMemo, type ReactNode } from 'react';
import { extractSessionFromURL } from './extract';
import { cleanSessionFromURL } from './cleanURL';
import { loadToken, saveToken } from './storage';
import type { SessionToken } from './types';

export interface SessionContextValue {
  token: SessionToken | null;
  gameId: string | null;
}

export const SessionContext = createContext<SessionContextValue | null>(null);

export function SessionProvider({ children }: { children: ReactNode }) {
  const value = useMemo<SessionContextValue>(() => {
    const extracted = extractSessionFromURL(window.location.href);
    if (extracted.token) {
      saveToken(extracted.token);
      cleanSessionFromURL();
      return { token: extracted.token, gameId: extracted.gameId };
    }
    return { token: loadToken(), gameId: extracted.gameId };
  }, []);

  return <SessionContext value={value}>{children}</SessionContext>;
}
